import React from 'react'
import { DataCheckedType } from '../../control/CheckboxGroup'

const useCheckbox = () => {
    const data = [
        {
            id: '1',
            name: 'Button',
            value: 'button',
        },
        {
            id: '2',
            name: 'Loading',
            value: 'loading',
        },
    ]
    const data2 = [
        {
            id: 1,
            name: 'Button',
            value: 'button',
        },
        {
            id: 2,
            name: 'Loading',
            value: 'loading',
        },
    ]

    const [checked, setCheck] = React.useState<boolean>()

    const handleClick = (checked: boolean) => {
        setCheck(checked)
    }

    const handleClickForGroup = (data: DataCheckedType) => {
        setCheck(checked)
    }

    return {
        dataList: data,
        dataListGroup: data2,
        checked: checked,
        onClick: handleClick,
        onClickForGroup: handleClickForGroup,
    }
}

export default useCheckbox
